import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { createElement } from 'react';
import { attachProps, camelToDashCase, createForwardRef, dashToPascalCase, isCoveredByReact, mergeRefs } from './utils';
export var createReactComponent = function createReactComponent(tagName, ReactComponentContext, manipulatePropsFunction, defineCustomElement) {
  if (defineCustomElement !== undefined) {
    defineCustomElement();
  }
  var displayName = dashToPascalCase(tagName);
  var ReactComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(ReactComponent, _React$Component);
    function ReactComponent(props) {
      var _this;
      _classCallCheck(this, ReactComponent);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactComponent).call(this, props));
      _this.setComponentElRef = function (element) {
        _this.componentEl = element;
      };
      return _this;
    }
    _createClass(ReactComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        attachProps(this.componentEl, this.props, prevProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _a = this.props,
          children = _a.children,
          forwardedRef = _a.forwardedRef,
          style = _a.style,
          className = _a.className,
          ref = _a.ref,
          cProps = __rest(_a, ["children", "forwardedRef", "style", "className", "ref"]);
        var propsToPass = Object.keys(cProps).reduce(function (acc, name) {
          var value = cProps[name];
          if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
            var eventName = name.substring(2).toLowerCase();
            if (typeof document !== 'undefined' && isCoveredByReact(eventName)) {
              acc[name] = value;
            }
          } else {
            // we should only render strings, booleans, and numbers as attrs in html.
            // objects, functions, arrays etc get synced via properties on mount.
            var type = typeof value;
            if (type === 'string' || type === 'boolean' || type === 'number') {
              acc[camelToDashCase(name)] = value;
            }
          }
          return acc;
        }, {});
        if (manipulatePropsFunction) {
          propsToPass = manipulatePropsFunction(this.props, propsToPass);
        }
        var newProps = Object.assign(Object.assign({}, propsToPass), {
          ref: mergeRefs(forwardedRef, this.setComponentElRef),
          style: style
        });
        /**
         * We use createElement here instead of
         * React.createElement to work around a
         * bug in Vite (https://github.com/vitejs/vite/issues/6104).
         * React.createElement causes all elements to be rendered
         * as <tagname> instead of the actual Web Component.
         */
        return createElement(tagName, newProps, children);
      }
    }], [{
      key: "displayName",
      get: function get() {
        return displayName;
      }
    }]);
    return ReactComponent;
  }(React.Component);
  // If context was passed to createReactComponent then conditionally add it to the Component Class
  if (ReactComponentContext) {
    ReactComponent.contextType = ReactComponentContext;
  }
  return createForwardRef(ReactComponent, displayName);
};